import { useState, useRef } from "react";
import { API_URL, getValFromLS, isFieldError } from "../../helpers";
import Input from "../../components/Input";
import Select from "../../components/Select";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

const Form = ({ giftDisabled, values, success }) => {
  const [errors, setErrors] = useState([]);
  const [names, setNames] = useState({ ...values });
  const [msg, setMsg] = useState({});

  const formElement = useRef(null);

  const handleUpdate = (name, value) => {
    setNames((names) => ({ ...names, [name]: value ? value : "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrors([]);
    setMsg({
      type: "working",
      text: "",
    });

    const url = new URL(`${API_URL}/admin/guest2`);
    let data = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      data.append(key, value);
    });
    data.append("token", getValFromLS("vtoUserToken"));

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        setMsg({});

        success(json.text, json.guestId);
      } else {
        setErrors(json.fields);
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <form
      ref={formElement}
      method="post"
      action="/"
      onSubmit={(e) => handleSubmit(e)}
      className="well"
      style={{ marginTop: "25px" }}
    >
      <h4
        style={{
          marginTop: "0",
          lineHeight: "22px",
          marginBottom: "15px",
          fontSize: "1.1rem",
        }}
      >
        Admin Managed Guest Preferences
      </h4>

      <div className="form-group">
        <Select
          name="pickedup"
          label="Picked Up Gift Package"
          reqd={false}
          value={names.pickedup}
          options={[
            { id: "", name: "--" },
            {
              id: "Shipped Entire Gift Package",
              name: "Shipped Entire Gift Package",
            },
            {
              id: "Shipped Partial Gift Package",
              name: "Shipped Partial Gift Package",
            },
          ]}
          update={handleUpdate}
          error={isFieldError(errors, "pickedup")}
        />

        <Select
          name="gift"
          label="Gift"
          reqd={false}
          value={names.gift}
          options={[
            { id: "", name: "--" },
            {
              id: "Ladies Madison Perfed Hybrid - Sand Nubuck",
              name: "Ladies Madison Perfed Hybrid - Sand Nubuck",
            },
            {
              id: "Ladies XC4® Womens H2-Sport Hybrid - Black/Silver Waterproof Knit",
              name: "Ladies XC4® Womens H2-Sport Hybrid - Black/Silver Waterproof Knit",
            },
            {
              id: "Mens McGuffey GL2 Hybrid - Tan Oiled Emb Full Grain",
              name: "Mens McGuffey GL2 Hybrid - Tan Oiled Emb Full Grain",
            },
            {
              id: "Mens McGuffey GL2 Hybrid - Navy Oiled Emb Full Grain",
              name: "Mens McGuffey GL2 Hybrid - Navy Oiled Emb Full Grain",
            },
            {
              id: "Mens H1 Luxe Hybrid Ran Waterproof Full-Grain Leather",
              name: "Mens H1 Luxe Hybrid Ran Waterproof Full-Grain Leather",
            },
            {
              id: "Mens H2 Sport Hybrid Gray Knit",
              name: "Mens H2 Sport Hybrid Gray Knit",
            },
          ]}
          update={handleUpdate}
          error={isFieldError(errors, "gift")}
        />
      </div>

      <div className="form-group one">
        <Input
          name="notes"
          label="Notes"
          reqd={false}
          value={names.notes}
          autocomplete="off"
          update={handleUpdate}
          errors={errors}
        />
      </div>

      <div className="msg-submit" style={{ marginTop: "30px" }}>
        {msg.type && <Msg data={msg} />}

        <div
          className={
            msg.type === "working" || msg.type === "success"
              ? "hidden"
              : "submit-container"
          }
        >
          <Submit submit="Update Guest Preferences" />
        </div>
      </div>

      {names.updated && (
        <p style={{ marginTop: "20px", marginBottom: "0" }}>{names.updated}</p>
      )}
    </form>
  );
};

export default Form;
